import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";
import { usePortalAuth } from "../context/PortalAuth";

export default function PortalCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { setUser } = usePortalAuth();
  const processed = useRef(false);

  useEffect(() => {
    // useRef pattern: guards against StrictMode double-invoke.
    if (processed.current) return;
    processed.current = true;

    // Parse `session_id` out of the URL fragment set by Emergent Auth.
    const raw = location.hash?.replace(/^#/, "") || "";
    const params = new URLSearchParams(raw);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      nav("/portal/login", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/portal/auth/google/session", { session_id: sessionId });
        setUser(data);
        // Clear the fragment so subsequent renders don't reprocess it.
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(`Welcome, ${data.name || "friend"}.`);
        nav("/portal", { replace: true, state: { user: data } });
      } catch (e) {
        const msg = e?.response?.data?.detail || "Google sign-in failed.";
        toast.error(msg);
        nav("/portal/login", { replace: true });
      }
    })();
  }, [location.hash, nav, setUser]);

  return (
    <div className="min-h-screen bg-[#eae7de] flex items-center justify-center gap-3 text-[#1e3d3a]/60 text-sm">
      <Loader2 className="h-4 w-4 animate-spin" /> Finishing sign-in…
    </div>
  );
}
